const productRepository = require('../repositories/products.json');

export default class Product {

    constructor(properties) {
        Object.assign(this, {
            basePrice: 0,
            vatPercentage: 0,
            priceTable: [],
            minOrderable: 1,
            maxOrderable: null,
        }, properties);
    }

    getMinimalQuantity() {
        return this.minOrderable;
    }

    getMaximalQuantity() {
        return this.maxOrderable === null ? Infinity : this.maxOrderable;
    }

    getPriceForQuantity(quantity) {
       return this.getBasePriceForQuantity(quantity) * quantity;
    }

    getBasePriceForQuantity(quantity) {
        quantity = quantity > 0 ? quantity: 0;

        const priceTable = this.getPriceTableByQuantity(quantity);

        if(priceTable === null) {
            if(quantity >= this.getMinimalQuantity() && quantity <= this.getMaximalQuantity()) {
                return this.basePrice;
            }

            throw 'Prijstabel kon niet worden gevonden!';
        }

        return priceTable.price;
    }

    getPriceTableByQuantity(quantity) {
        if(this.priceTable.length === 0) {
            return null;
        }

        let min, max;
        for(let i in this.priceTable) {
            let minMax = this.priceTable[i].value.split('-');
            if(minMax.length > 1) {
                min = parseInt(minMax[0]);
                max = parseInt(minMax[1]);
            } else {
                min = parseInt(minMax[0]);
                max = parseInt(minMax[0]);
            }

            switch(this.priceTable[i].condition) {
                case '>':
                    if(quantity > min) {
                        return this.priceTable[i];
                    }
                    break;

                case 'between':
                    if(quantity <= max && quantity >= min) {
                        return this.priceTable[i]
                    }
                    break;
            }
        }

        return null;
    }

    static getById(id) {
        id = parseInt(id);

        return new Product(
            productRepository.products.find((item) => item.id === id)
        );
    }
}
